/**
 * @date: 2025-08-23 12:11:20
 * @description: 登录相关接口
 * @modifyContent:
 * @author: Forever丿顾北
**/
import request from '@/utils/Request';
import {
  SendCaptchaRequest,
  LoginRequest,
  LoginData,
  LoginOutRequest,
  LoginOutData
} from './type';
import { CommonResponse } from '@/Api/Components/type';

/**
 * @date: 2025-08-23 12:12:20
 * @description: 发送登录验证码
 * @modifyContent:
 * @author: Forever丿顾北
**/
export const post_Send_Captcha = (data: SendCaptchaRequest) => {
  // 发送验证码不需要返回具体数据，使用空对象
  return request.post<CommonResponse<{}>>('/api/auth/send_captcha', data);
};

/**
 * @date: 2025-08-23 12:13:20
 * @description: 登录
 * @modifyContent:
 * @author: Forever丿顾北
**/
export const post_Login = (data: LoginRequest) => {
  return request.post<LoginData>('/api/auth/login', data);
};

/**
 * @date: 2025-08-23 12:14:20
 * @description: 退出登录
 * @modifyContent:
 * @author: Forever丿顾北
**/
export const post_Login_Out = (data: LoginOutRequest) => {
  return request.post<CommonResponse<LoginOutData>>('/api/auth/logout', data);
};